'use strict';

import { getCart, updateCart } from './cart-api.js';

document.addEventListener('DOMContentLoaded', () => {
  const gwpRestrictionsCollection = window.gwpRestrictionsCollection || null;
  const trainingRestrictionsCollection = window.trainingRestrictionsCollection || null;
  const enablePurchaseOnlyForAcneExperts = window.enablePurchaseOnlyForAcneExperts;

  document.querySelectorAll('a.logout-button').forEach((logoutButton) => {
    logoutButton.addEventListener('click', (event) => {
      if (enablePurchaseOnlyForAcneExperts) {
        if (gwpRestrictionsCollection || trainingRestrictionsCollection) {
          event.preventDefault();
          cleanUpCart(gwpRestrictionsCollection, trainingRestrictionsCollection, logoutButton.href);
        }
      }
    });
  });
});

const getCollectionProductsIds = (gwpRestrictionsCollection, trainingRestrictionsCollection) => {
  let allowedProducts = [];

  if (gwpRestrictionsCollection) {
    gwpRestrictionsCollection.map((product) => allowedProducts.push(product.id));
  }
  if (trainingRestrictionsCollection) {
    trainingRestrictionsCollection.map((product) => allowedProducts.push(product.id));
  }

  return allowedProducts;
};

const cleanUpCart = async (gwpRestrictionsCollection, trainingRestrictionsCollection, href) => {
  try {
    const allowedProductIds = getCollectionProductsIds(
      gwpRestrictionsCollection,
      trainingRestrictionsCollection
    );
    const cart = await getCart();
    const itemsToRemove = cart.items.filter(
      (item) => !allowedProductIds.includes(item.product_id)
    );

    const removalResponses = [];
    for (const item of itemsToRemove) {
      const response = await updateCart({
        id: item.key,
        quantity: 0,
        sections: getSectionsToReload().map((section) => section.id),
      });

      removalResponses.push(response);
    }

    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'check-cart-logout' });

    removalResponses.forEach((response) => {
      reloadSections(response);
    });

    window.location.href = href;
  } catch (error) {
    console.error('Error cleaning up the cart:', error);
  }
};

const reloadSections = (parsedState) => {
  getSectionsToReload().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);

    if (sectionElement) {
      sectionElement.innerHTML = getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }
  });
};

const getSectionInnerHTML = (html, selector = '.shopify-section') => {
  return new DOMParser()
  .parseFromString(html, 'text/html')
  .querySelector(selector).innerHTML;
};

const getSectionsToReload = () => {
  return [
    {
      id: 'cart-drawer',
      selector: '#CartDrawer',
    },
    {
      id: 'cart-icon-bubble'
    }
  ];
};